import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Motion";

export function TestimonialCard({ t, dark = false }) {
  return (
    <figure data-testid={`testimonial-${t.id}`} className="flex h-full flex-col">
      <span className="block font-serif text-4xl leading-none text-progress" aria-hidden="true">
        “
      </span>
      <blockquote className={`mt-4 flex-1 font-serif text-lg leading-relaxed md:text-xl ${dark ? "text-paper/90" : "text-obsidian/90"}`}>
        {t.quote}
      </blockquote>
      <figcaption className={`mt-8 text-xs font-bold uppercase tracking-[0.18em] ${dark ? "text-paper/70" : "text-obsidian/70"}`}>
        {t.client}
        {t.role && (
          <span className={`mt-1 block font-medium normal-case tracking-normal ${dark ? "text-paper/45" : "text-slategray"}`}>
            {t.role}
          </span>
        )}
      </figcaption>
    </figure>
  );
}

export default function Testimonials({ items, dark = false, className = "", title = "In their words", moreHref, moreLabel }) {
  if (!items || items.length === 0) return null;
  const surface = dark ? "bg-obsidian" : "bg-paper";

  return (
    <section data-testid="testimonials-module" className={`${dark ? "bg-obsidian text-paper" : "bg-paper"} ${className}`}>
      <div className="mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28">
        <Reveal className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <div>
            <Eyebrow light={dark}>What clients say</Eyebrow>
            <h2 className="mt-6 max-w-3xl font-serif text-3xl font-medium leading-tight tracking-tight md:text-5xl">{title}</h2>
          </div>
          {moreHref && (
            <Link
              to={moreHref}
              data-testid="testimonials-more-link"
              className={`group inline-flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.14em] transition-colors duration-200 hover:text-progress ${dark ? "text-paper/80" : "text-obsidian"}`}
            >
              {moreLabel || "Read all testimonials"}
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          )}
        </Reveal>
        <div className="mt-14 grid gap-px border border-ash/40 bg-ash/40 md:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <Reveal key={t.id || i} delay={Math.min(i, 5) * 0.06} className={`${surface} flex flex-col p-8 md:p-10`}>
              <TestimonialCard t={t} dark={dark} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
